module.exports = __webpack_public_path__ + "img/walletconnect-logo.8d6f1db3.svg";